"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRouterDom = require("react-router-dom");
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _ThemeService = require("../common/ThemeService");
var _DispatcherFunction = require("../../dist/common/DispatcherFunction");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var PlayerStatsTable = /*#__PURE__*/function (_React$Component) {
  _inherits(PlayerStatsTable, _React$Component);
  var _super = _createSuper(PlayerStatsTable);
  function PlayerStatsTable(props) {
    var _this;
    _classCallCheck(this, PlayerStatsTable);
    _this = _super.call(this, props);
    _this.getCorlorCodForGrade = function (grade) {
      if (grade === 'A') return '#7ED321';
      if (grade === 'B') return '#7ED321';
      if (grade === 'C') return '#FFC814';
      if (grade === 'D') return '#FE8F40';
      if (grade === 'E') return '#FF4E3E';
    };
    _this.logActivityHit = function (lessons, stat, grade, e) {
      var activityTrack = [],
        track = {
          hit_timestamp: (0, _moment["default"])().format(),
          session_id: localStorage.getItem("token"),
          userid: localStorage.getItem("username"),
          deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
          hit_page: 'ReportCard',
          hit_type: 'ReportCardClinicVisit',
          hit_attribute1: lessons,
          hit_attribute2: stat,
          hit_attribute3: grade,
          hit_attribute4: _this.props.summaryInfo.medal,
          hit_attribute5: '',
          hit_attribute6: localStorage.getItem("accountName")
        };
      if (localStorage.getItem('activityTrack')) activityTrack = JSON.parse(localStorage.getItem('activityTrack'));
      activityTrack.push(track);
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack));
    };
    _this.getLuckPercentage = function (WinRatePercent) {
      return WinRatePercent === 0 ? 50 : WinRatePercent / 14 * 100 / 2 + 50;
    };
    _this.getComment = function (luckLevel) {
      switch (luckLevel) {
        case "Very Lucky":
          return _this.props.i18next.veryluckyShowdown;
        case "Lucky":
          return _this.props.i18next.luckyShowdown;
        case "Average":
          return _this.props.i18next.averagelyluckyShowdown;
        case "Unlucky":
          return _this.props.i18next.unluckyShowdown;
        case "Very Unlucky":
          return _this.props.i18next.veryunluckyShowdown;
        default:
          return "";
      }
    };
    _this.state = {
      expanded: false,
      fromClient: JSON.parse(localStorage.getItem('fromClient', false))
    };
    return _this;
  }
  _createClass(PlayerStatsTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var themeColor = (0, _ThemeService.getColor)();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], null), /*#__PURE__*/_react["default"].createElement("table", {
        className: "resp-table",
        style: {
          width: "100%",
          fontSize: "14px",
          color: '#020202'
        }
      }, /*#__PURE__*/_react["default"].createElement("thead", {
        className: "resp-table-head"
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        className: "resp-table-tr",
        style: {
          backgroundColor: "#fff !important"
        }
      }, /*#__PURE__*/_react["default"].createElement("th", {
        width: "10%",
        className: "resp_playerStat_th"
      }, this.props.i18next.Stat), /*#__PURE__*/_react["default"].createElement("th", {
        width: "1%",
        className: "resp_playerStat_th hide-prop"
      }), /*#__PURE__*/_react["default"].createElement("th", {
        width: "6%",
        className: "resp_playerStat_th"
      }, this.props.i18next.Grade), /*#__PURE__*/_react["default"].createElement("th", {
        width: "7%",
        className: "resp_playerStat_th"
      }, this.props.i18next.Value), /*#__PURE__*/_react["default"].createElement("th", {
        width: "12%",
        className: "resp_playerStat_th"
      }, this.props.i18next.preferedRange), /*#__PURE__*/_react["default"].createElement("th", {
        width: "10%",
        className: "resp_playerStat_th"
      }, this.props.i18next.handsRequired), /*#__PURE__*/_react["default"].createElement("th", {
        width: "32%",
        className: "resp_playerStat_th hideCommentForTabletViewOnly"
      }, this.props.i18next.comment), !this.props.sharedReport && /*#__PURE__*/_react["default"].createElement("th", {
        className: "resp_playerStat_th resp_playerStat_th_lessonWidth"
      }, this.props.i18next.suggestedLesson))), /*#__PURE__*/_react["default"].createElement("tbody", {
        "data-e2e": "catInsideTable",
        className: "resp-table-body"
      }, console.log("this.props.luckfactor>>>>", this.props.luckfactor), this.props.playerStatistics.map(function (key, index) {
        if (key.stat === 'Win Rate Ev Allin Adjusted') {
          key.stat = "Winrate – All-In EV Adjusted";
        }
        if (key.stat === "Win Rate EV Copy") {
          if (key.showOnlyNote) {
            return /*#__PURE__*/_react["default"].createElement("tr", {
              className: "resp_playerStat_tr"
            }, /*#__PURE__*/_react["default"].createElement("td", {
              key: index,
              className: "luckometer_main",
              colSpan: "8"
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "EV_temp_note"
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "EV_temp_note_heading"
            }, _this2.props.i18next.Note, ":"), /*#__PURE__*/_react["default"].createElement("span", {
              className: "EV_temp_note_text"
            }, "\xA0", _this2.props.i18next.lukoNotAvailabledaterange, "."))));
          } else {
            var luckPercent = 0;
            if (_this2.props.luckfactor) {
              luckPercent = _this2.getLuckPercentage(parseFloat(_this2.props.luckfactor.winRateandEvDiff));
              if (luckPercent < 0) {
                luckPercent = 0;
              } else if (luckPercent > 100) {
                luckPercent = 100;
              }
              return _this2.props.category == key.category && /*#__PURE__*/_react["default"].createElement("tr", {
                className: "resp_playerStat_tr",
                style: {
                  backgroundColor: "#fff !important"
                }
              }, /*#__PURE__*/_react["default"].createElement("td", {
                key: index,
                className: "luckometer_main",
                colSpan: "8"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "luckoM_heading"
              }, _this2.props.i18next.allInEquity, ":", /*#__PURE__*/_react["default"].createElement("span", {
                style: {
                  textTransform: "capitalize"
                }
              }, " ", _this2.props.i18next.youBeen, _this2.props.luckfactor ? _this2.props.luckfactor.luckLevel : "", "!")), /*#__PURE__*/_react["default"].createElement("div", {
                className: "luckoM_comment"
              }, _this2.props.luckfactor ? _this2.getComment(_this2.props.luckfactor.luckLevel) : ""), /*#__PURE__*/_react["default"].createElement("div", {
                className: "luckometer"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "luckometer_bar"
              }, " ", /*#__PURE__*/_react["default"].createElement("i", {
                className: "fa fa-map-marker luckometer_thumb",
                style: {
                  left: luckPercent + "%"
                }
              }), " ")), /*#__PURE__*/_react["default"].createElement("div", {
                className: "luck_status_lables"
              }, /*#__PURE__*/_react["default"].createElement("div", null, _this2.props.i18next.veryUnlucky), /*#__PURE__*/_react["default"].createElement("div", {
                className: "hide_luckLable_for_mobile"
              }, _this2.props.i18next.unlucky), /*#__PURE__*/_react["default"].createElement("div", {
                className: "hide_luckLable_for_mobile"
              }, _this2.props.i18next.average), /*#__PURE__*/_react["default"].createElement("div", {
                className: "hide_luckLable_for_mobile"
              }, "\xA0", _this2.props.i18next.lucky, "\xA0"), /*#__PURE__*/_react["default"].createElement("div", null, "\xA0\xA0", _this2.props.i18next.veryLucky))));
            }
          }
        } else {
          var lessonsList = !_this2.props.sharedReport ? key.lessons.filter(function (item) {
            return item != "";
          }) : [];
          var resp_playerStat_td = "resp_playerStat_td ".concat(key.stat === "Winrate – All-In EV Adjusted" ? "resp_playerStat_td_remove_boder" : "");
          return _this2.props.category.trim() == key.category.trim() && /*#__PURE__*/_react["default"].createElement("tr", {
            key: index,
            style: {
              backgroundColor: "#fff !important"
            },
            className: "resp_playerStat_tr ".concat(key.stat === "Winrate – All-In EV Adjusted" ? "resp_playerStat_tr_remove_boder" : "")
          }, /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "Stat:",
            className: resp_playerStat_td
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "titleUnderline",
            style: {
              display: "inline-block",
              paddingTop: "10px",
              position: "relative"
            }
          }, (key.stat ? key.stat.replace(" %", "%") : key.stat) + " ", /*#__PURE__*/_react["default"].createElement("i", {
            style: {
              color: themeColor
            },
            className: "fa fa-question-circle tooltip_icon_circle",
            "data-tip": key.toolTip,
            "aria-hidden": "true"
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: "showCommentForTabletViewOnly",
            style: {
              fontSize: "12px",
              marginTop: "3px",
              position: "absolute",
              width: "62%"
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginTop: "10px",
              color: "#383838",
              fontFamily: "Roboto",
              fontSize: "12px",
              letterSpacing: "0.03px",
              lineHeight: "14px"
            }
          }, _this2.props.i18next.comment, ":"), /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              color: "#383838",
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "bold",
              letterSpacing: "0.03px",
              lineHeight: "14px"
            }
          }, key.comment))), /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "",
            style: {
              padding: '0'
            },
            className: resp_playerStat_td + " hide-prop"
          }), /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "Grade:",
            className: resp_playerStat_td + "grade_padding_top_for_mobile_View"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "cursive",
            style: {
              color: _this2.getCorlorCodForGrade(key.grade),
              fontSize: '2em',
              fontWeight: 'bold'
            }
          }, key.grade)), /*#__PURE__*/_react["default"].createElement("td", {
            "data-e2e": "reportCardValues",
            "data-title": "Value:",
            className: resp_playerStat_td
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "value_mobile_view_css"
          }, key.value != null ? key.value : "INF")), /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "A Grade Range:",
            className: resp_playerStat_td
          }, ["Win Rate", "Winrate – All-In EV Adjusted"].indexOf(key.stat) != -1 && _this2.props.gameType === 'plo' && key.prefRange === '4-9999' ? '4+' : key.prefRange), /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "Minimum Hands Required:",
            className: resp_playerStat_td
          }, key.minimum_hand_requirement + "+", key.minimum_hand_requirement < _this2.props.handsAnalysed || key.minimum_hand_requirement == _this2.props.handsAnalysed ? null : /*#__PURE__*/_react["default"].createElement("i", {
            style: {
              color: '#DE460F'
            },
            className: "fa fa-exclamation-triangle",
            "data-tip": "Insufficient hands played for this statistic to be reliable",
            "aria-hidden": "true"
          })), /*#__PURE__*/_react["default"].createElement("td", {
            "data-title": "Comment:",
            style: {
              fontSize: 12,
              marginTop: "11px"
            },
            className: resp_playerStat_td + " hideCommentForTabletViewOnly "
          }, key.comment), /*#__PURE__*/_react["default"].createElement("td", {
            // data-title={'Suggested Lesson' + (key.lessons && key.lessons.length > 1 ? "s:" : ":")}
            className: resp_playerStat_td + " resp_playerStat_td_livereport resp_playerStat_td_lesson "
          }, lessonsList.length > 0 && _this2.props.gameType != 'plo' ? lessonsList.map(function (lessons, index) {
            var lessonName = lessons.split('/')[1] ? lessons.split('/')[1] : lessons.split('/')[0];
            return /*#__PURE__*/_react["default"].createElement("div", null, !_this2.state.fromClient ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
              "data-e2e": "lesson-".concat(lessonName ? lessonName.replace(/\s/g, '') : ""),
              key: index,
              style: {
                cursor: 'pointer',
                margin: '10px 0px',
                minWidth: "200px",
                textAlign: 'left',
                fontSize: '13px',
                textDecoration: 'none'
              },
              to: {
                pathname: "/reportCardCourse/".concat(lessons.split('/')[0]),
                search: "?source=report-card&lessons=".concat(lessons.split('/')[0], "&stat=").concat(key.stat, "&grade=").concat(key.grade, "&sublesson=").concat(lessons.split('/')[1], "&accountName=").concat(_this2.props.accountName, "&fromClient=").concat(_this2.state.fromClient),
                state: {
                  redirectedFrom: 'report-card',
                  prevPath: _this2.props.path
                }
              },
              target: _this2.props.isLiveview ? "_blank" : "_self",
              className: "mg-btn saffron liviviewLessonBtn reportCardLessonLink",
              onClick: function onClick() {
                _this2.props.saveCourseRedirection(key.category, lessonName, key.stat, key.grade);
              }
            }, console.log("lessonName", _this2.props.i18next.t(lessonName.replace(/\s/g, '')), _this2.props.i18next), /*#__PURE__*/_react["default"].createElement("i", {
              className: "fa fa-play-circle-o"
            }), "\xA0", lessonName ? _this2.props.i18next.t("lable." + lessonName.replace(/\s/g, '')) : "") :
            /*#__PURE__*/
            //for vc and mac clients
            _react["default"].createElement("a", {
              "data-e2e": "lesson-".concat(lessonName ? lessonName.replace(/\s/g, '') : ""),
              key: index,
              style: {
                cursor: 'pointer',
                margin: '10px 0px',
                minWidth: "200px",
                textAlign: 'left',
                fontSize: '13px',
                textDecoration: 'none'
              },
              className: "mg-btn saffron liviviewLessonBtn reportCardLessonLink",
              onClick: function onClick() {
                (0, _DispatcherFunction.DispatcherFunction)("app:menu=3812&name=MYGAME_COURSES", {
                  "MYGAME_COURSES_URL": "https://" + window.location.hostname + "/reportCardCourse/".concat(lessons.split('/')[0].replace(/ /g, "%20")) + "?source=report-card&lessons=".concat(lessons.split('/')[0].replace(/ /g, "%20"), "&stat=").concat(key.stat.replace(/ /g, "%20").replace(/%20%/g, "%20").endsWith("%") ? key.stat.replace(/ /g, "%20").replace(/%20%/g, "%20").slice(0, -1) : key.stat.replace(/ /g, "%20").replace(/%20%/g, "%20"), "&grade=").concat(key.grade.replace(/ /g, "%20"), "&sublesson=").concat(typeof lessons.split('/')[1] == 'undefined' ? lessons.split('/')[1] : lessons.split('/')[1].replace(/ /g, "%20"), "&accountName=").concat(_this2.props.accountName, "&fromClient=").concat(_this2.state.fromClient)
                });
                _this2.props.saveCourseRedirection(lessonName, key.stat, key.grade);
              }
            }, /*#__PURE__*/_react["default"].createElement("i", {
              className: "fa fa-play-circle-o"
            }), "\xA0", lessonName ? _this2.props.i18next.t("lable." + lessonName.replace(/\s/g, '')) : ""));
          }) : "-"));
        }
      }))));
    }
  }]);
  return PlayerStatsTable;
}(_react["default"].Component);
var _default = (0, _reactRouterDom.withRouter)(PlayerStatsTable);
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/PlayerStatsTable.js
 ** module id = 2393
 ** module chunks = 0
 **/